import { CheckIcon } from "@aureskonnect/react-ui";
import { customColumnProps } from "@maherunlocker/custom-react-table";
import React, { memo } from "react";
import CustomIcons from "./CustomIcons";

export interface ColumnFactoryOptions {
    t: (key: string) => string;
    setSelectedRows?: (rows: any[]) => void;
    setMergedData: Function;
    setIsFetchingData: Function;
}
export interface BreadcrumbItem {
    item: string;
    link: string;
}

export interface BreadcrumbOptions {
    t: (key: string) => string;
    selectedAccount?: string;
    oneShop?: boolean;
}

export const CheckIconWebsite = memo(({ e }: any) => {
    if (
        e.selectedRow?.subRows !== undefined ||
        e.selectedRow["Web site"] !== 1
    ) {
        return null;
    }
    return (
        <CheckIcon
            className="mt-1 ml-1 cmn_chk_selectButton"
            height={23}
            width={23}
        />
    );
});

export const CheckIconApplicationOrder = memo(({ e }: any) => {
    if (e.selectedRow?.subRows !== undefined || !e.selectedRow.application) {
        return null;
    }
    return (
        <CheckIcon
            className="mt-1 ml-1 cmn_chk_selectButton"
            height={23}
            width={23}
        />
    );
});

export const createActionsColumn = (
    t: (key: string) => string,
    setSelectedRows: (rows: any[]) => void,
    setMergedData: Function,
    setIsFetchingData: Function
): customColumnProps => ({
    indexOFColumn: 999,
    columnName: t("Actions"),
    customJsx: (e: any) => (
        <CustomIcons
            e={e}
            setSelectedRows={setSelectedRows}
            setMergedData={setMergedData}
            setIsFetchingData={setIsFetchingData}
        />
    ),
    disableFilter: false,
});

export const createApplicationColumn = (
    t: (key: string) => string
): customColumnProps => ({
    indexOFColumn: 4,
    columnName: t("Application"),
    customJsx: (e: any) => <CheckIconApplicationOrder e={e} />,
});

export const createWebsiteColumn = (
    t: (key: string) => string
): customColumnProps => ({
    indexOFColumn: 5,
    columnName: t("Web site"),
    customJsx: (e: any) => <CheckIconWebsite e={e} />,
});

export const createCCSetupColumns = (
    options: ColumnFactoryOptions
): customColumnProps[] => {
    const { t, setSelectedRows, setMergedData, setIsFetchingData } = options;

    if (!setSelectedRows) {
        throw new Error("setSelectedRows is required for C&C setup columns");
    }

    return [
        createActionsColumn(
            t,
            setSelectedRows,
            setMergedData,
            setIsFetchingData
        ),
        createApplicationColumn(t),
        createWebsiteColumn(t),
    ];
};

export const createCCSetupBreadcrumb = (
    options: BreadcrumbOptions
): BreadcrumbItem[] => {
    const { t, selectedAccount, oneShop } = options;

    return [
        {
            item: "SETTINGS",
            link: `${process.env.REACT_APP_PORTAIL_URL}`,
        },
        {
            item: selectedAccount?.toUpperCase() || "",
            link: oneShop ? "/setting/customer-account" : "/compte",
        },
        {
            item: t("Application").toUpperCase(),
            link: "applications",
        },
        {
            item: t("C&C").toUpperCase(),
            link: "c&c",
        },
        {
            item: t("C&C Setup").toUpperCase(),
            link: "Configuration",
        },
    ];
};
